export const GENRE_ID = {
  ACTION: "eccbc87e4b5ce2fe28308fd9f2a7baf3_929372c",
  ANIMATION: "6364d3f0f495b6ab9dcf8d3b5c6e0b01_929372c",
  KIDS: "9f61408e3afb633e50cdf1b20de6f466_929372c",
  DANISH: "735b90b4568125ed6c3f678819b6e058_929372c",
  DOCUMENTARY: "1c383cd30b7c298ab50293adfecb7b18_929372c",
  DRAMA: "45c48cce2e2d7fbdea1afc51c7c6ad26_929372c",
  ADVENTURE: "ea5d2f1c4608232e07d3aa3d998e5135_929372c",
  FAMILY: "a3f390d88e4c41f2747bfa2f1b5f87db_929372c",
  FANTASY: "14bfa6bb14875e45bba028a21ed38046_929372c",
  HORROR: "4e732ced3463d06de0ca9a15b6153677_929372c",
  COMEDY: "1679091c5a880faf6fb5e6087eb1b2dc_929372c",
  WAR: "d645920e395fedad7bbbed0eca3fe2e0_929372c",
  CRIME: "3416a75f4cea9109507cacd8e2f2aefc_929372c",
  MUSICAL: "17e62166fc8586dfa4d1bc0e1742c08b_929372c",
  MYSTERY: "ad61ab143223efbc24c7d2583be69251_929372c",
  OTHER: "aab3238922bcc25a6f606eb525ffdc56_929372c",
  ROMANCE: "c9f0f895fb98ab9159f51fd0297e236d_929372c",
  SCIENCE_FICTION: "f7177163c833dff4b38fc8d2872f1ec6_929372c",
  STAND_UP: "b53b3a3d6ab90ce0268229151c9bde11_929372c",
  THRILLER: "a87ff679a2f3e71d9181a67b7542122c_929372c",
  WESTERN: "e369853df766fa44e1ed0ff613f563bd_929372c",
} as const;

export const GENRE_ICON_BY_ID: Record<string, string> = {
  [GENRE_ID.ACTION]: "action.json",
  [GENRE_ID.ANIMATION]: "animation.json",
  [GENRE_ID.KIDS]: "kids.json",
  [GENRE_ID.DANISH]: "dansk.json",
  [GENRE_ID.DOCUMENTARY]: "documentary.json",
  [GENRE_ID.DRAMA]: "drama.json",
  [GENRE_ID.ADVENTURE]: "adventure.json",
  [GENRE_ID.FAMILY]: "family.json",
  [GENRE_ID.FANTASY]: "fantasy.json",
  [GENRE_ID.HORROR]: "horror.json",
  [GENRE_ID.COMEDY]: "comedy.json",
  [GENRE_ID.WAR]: "war.json",
  [GENRE_ID.CRIME]: "crime.json",
  [GENRE_ID.MUSICAL]: "musical.json",
  [GENRE_ID.MYSTERY]: "mystery.json",
  [GENRE_ID.OTHER]: "other.json",
  [GENRE_ID.ROMANCE]: "romance.json",
  [GENRE_ID.SCIENCE_FICTION]: "science-fiction.json",
  [GENRE_ID.STAND_UP]: "comedy.json",
  [GENRE_ID.THRILLER]: "thriller.json",
  [GENRE_ID.WESTERN]: "western.json",
} as const;
